import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import * as CommonAPI from '../../API/CommonAPI'
import { immer } from 'zustand/middleware/immer'

const initialState = {
    rollData: [],
    rollDataLoading: false,
    rollDataError: '',

    vacancyGovData: [],
    vacancyGovLoading: false,
    vacancyGovError: '',

    departmentByOrgId: [],
    departmentByOrgIdLoading: false,
    departmentByOrgIdError: '',

    designationByOrgId: [],
    designationByOrgIdLoading: false,
    designationByOrgIdError: '',

    designationByDepId: [],
    designationByDepIdLoading: false,
    designationByDepIdError: '',

    getAllFeaturesData: [],

    readNotificationById: [],
    readNotificationByIdLoading: false,
    readNotificationByIdError: '',

    getExistingEmailandPhonenoData: {},
    getExistingEmailandPhonenoLoading: false,
    getExistingEmailandPhonenoError: '',
    hasOrgs: false,
    orglogoLoading: false,
    orgLogo: {}
}

const CommonStore = create(devtools(immer((set, get) => ({
    ...initialState,

    getAllRole: async (orgId) => {
        set({ rollDataLoading: true })
        try {
            const response = await CommonAPI.getRollData(orgId)
            if (response.data) {
                set({ rollDataLoading: false, rollData: response.data })
            } else {
                set({ rollDataLoading: false, rollData: [], tableBodyData: initialState.tableBodyData })
            }
        } catch (error) {
            set({ rollDataError: error.message || 'An error occurred', rollDataLoading: false })
        }
    },
    getOrgLogo: async (orgId, userId) => {
        try {
            const response = await CommonAPI.getOrgLogoApi(orgId, userId)
            if (response.data) {
                set({ orgLogo: response.data })
            } else {
                set({ orgLogo: null })
            }
        } catch (error) {
            set({ rollDataError: error.message || 'An error occurred', orgLogoLoading: false })
        }
    },
    getHasOrgs: async (emailId, userId) => {
        try {
            const response = await CommonAPI.getHasOrgsApi(emailId, userId)
            if (response.data) {
                set({ hasOrgs: response.data })
            } else {
                set({ hasOrgs: null })
            }
        } catch (error) {
            set({ rollDataError: error.message || 'An error occurred', orgLogoLoading: false })
        }
    },

    getVacancyGov: async (orgId, userId) => {
        set({ vacancyGovLoading: true })
        try {
            const response = await CommonAPI.getVacancyGovApi(orgId, userId)
            if (response.data) {
                set({ vacancyGovError: false, vacancyGovData: response.data })
            } else {
                set({ vacancyGovError: false, vacancyGovData: [] })
            }
        } catch (error) {
            set({ vacancyGovError: error.message || 'An error occurred' })
        }
    },

    getAllDepartmentByOrgId: async (organizationId) => {
        set({ departmentByOrgIdLoading: true })
        try {
            const response = await CommonAPI.getAllDepartmentByOrgId(organizationId)
            if (response.data) {
                set({ departmentByOrgIdLoading: false, departmentByOrgId: response.data })
            } else {
                set({ departmentByOrgIdLoading: false, departmentByOrgId: initialState.departmentByOrgId })
            }
        } catch (error) {
            set({ departmentByOrgIdError: error.message || 'An error occurred', departmentByOrgIdLoading: false })
        }
    },

    getAllDesignationByOrgId: async (organizationId) => {
        set({ designationByOrgIdLoading: true })
        try {
            const response = await CommonAPI.getAllDesignationByOrgId(organizationId)
            if (response.data) {
                set({ designationByOrgIdLoading: false, designationByOrgId: response.data })
            } else {
                set({ designationByOrgIdLoading: false, designationByOrgId: initialState.departmentByOrgId })
            }
        } catch (error) {
            set({ designationByOrgIdError: error.message || 'An error occurred', designationByOrgIdLoading: false })
        }
    },

    getAllDesignationByDepId: async (depId) => {
        set({ designationByDepIdLoading: true })
        try {
            const response = await CommonAPI.getAllDesignationByDepId(depId)
            if (response.data) {
                set({ designationByDepIdLoading: false, designationByDepId: response.data })
            } else {
                set({ designationByDepIdLoading: false, designationByDepId: initialState.departmentByDepId })
            }
        } catch (error) {
            set({ designationByDepIdError: error.message || 'An error occurred', designationByDepIdLoading: false })
        }
    },
    getAllFeaturesF: async (userId) => {
        try {
            const res = await CommonAPI.getAllFeatures(userId)
            if (res.data.length > 0) {
                localStorage.setItem('features', JSON.stringify(res.data))
                set({ getAllFeaturesData: res.data })
                return res.data
            }
        } catch (error) {
            set({ designationByDepIdError: error.message })
        }
    },

    getAllNotification: async (userId) => {
        set({ getAllNotificationDataLoading: true })
        try {
            const response = await CommonAPI.getAllNotification(userId)
            if (response.data) {
                set({ getAllNotificationDataLoading: false, getAllNotificationData: response.data })
            } else {
                set({ getAllNotificationDataLoading: false, getAllNotificationData: [] })
            }
            return response.data
        } catch (error) {
            set({ getAllNotificationDataError: error.message || 'An error occurred', getAllNotificationDataLoading: false })
        }
    },

    readNotification: async (arrayOfId) => {
        set({ readNotificationByIdLoading: true })
        try {
            const response = await CommonAPI.readNotificationById(arrayOfId)
            if (response?.status === 200) {
                set({ readNotificationByIdLoading: false, readNotificationById: response })
                return response
            } else {
                set({ readNotificationByIdLoading: false, readNotificationById: [] })
            }
        } catch (error) {
            set({ readNotificationByIdError: error.message || 'An error occurred', readNotificationByIdLoading: false })
        }
    },

    getExistingEmailandPhoneno: async (payload) => {
        set({ getExistingEmailandPhonenoLoading: true })
        try {
            const response = await CommonAPI.getExistingEmailandPhoneno(payload)
            if (response) {
                set({ getExistingEmailandPhonenoLoading: false, getExistingEmailandPhonenoData: response.data })
                return response
            } else {
                set({ getExistingEmailandPhonenoLoading: false, getExistingEmailandPhonenoData: {} })
            }
        } catch (error) {
            set({ getExistingEmailandPhonenoError: error.message || 'An error occurred', getExistingEmailandPhonenoLoading: false })
        }
    }

}))))

export const useCommonStore = CommonStore

export const getVacancyGov = (orgId, userId) => {
    useCommonStore.getState().getVacancyGov(orgId, userId)
}
export const getOrgLogo = (orgId, userId) => {
    useCommonStore.getState().getOrgLogo(orgId, userId)
}
export const getHasOrgs = (emailId, userId) => {
    useCommonStore.getState().getHasOrgs(emailId, userId)
}
